import { seedOilDetectorGuide } from './seed-oil-detector-guide';
import { hiddenIngredientsProcessedFoods } from './hidden-ingredients-processed-foods';
import { understandingSeedOils } from './understanding-seed-oils';
import { howToCheckSeedOilsOnlineShopping } from './how-to-check-seed-oils-online-shopping';
import { artificialSweetenersGuide } from './artificial-sweeteners-guide';
import { readingIngredientLabels } from './reading-ingredient-labels';
import { aiIngredientScanner } from './ai-ingredient-scanner';
import { beyondAiDietApps } from './beyond-ai-diet-apps';
import { riseAiNutritionApps } from './rise-ai-nutrition-apps';
import { futureFoodTransparency } from './future-food-transparency';
import { aiNutritionCoachVsNutritionists } from './ai-nutrition-coach-vs-nutritionists';
import { aiFoodLensVsTraditionalFoodApps } from './ai-food-lens-vs-traditional-food-apps';
import { makesHealthyChoiceAffordable } from './makes-healthy-choice-affordable';
import { artificialFoodDyesGuide } from './artificial-food-dyes-guide';
import { foodIngredientScanner } from './food-ingredient-scanner';
import { howToReadNutritionLabels } from './how-to-read-nutrition-labels';
import { potassiumSorbateGuide } from './potassium-sorbate-guide';
import { foodPreservativesGuide } from './food-preservatives-guide';
import { ultraProcessedFoodsGuide } from './ultra-processed-foods-guide';

export const blogPostsData = {
  'seed-oil-detector-guide': seedOilDetectorGuide,
  'hidden-ingredients-processed-foods': hiddenIngredientsProcessedFoods,
  'ultra-processed-foods-guide': ultraProcessedFoodsGuide,
  'food-preservatives-guide': foodPreservativesGuide,
  'how-to-check-seed-oils-online-shopping': howToCheckSeedOilsOnlineShopping,
  'how-to-read-nutrition-labels': howToReadNutritionLabels,
  'potassium-sorbate-guide': potassiumSorbateGuide,
  'understanding-seed-oils': understandingSeedOils,
  'artificial-sweeteners-guide': artificialSweetenersGuide,
  'artificial-food-dyes-guide': artificialFoodDyesGuide,
  'reading-ingredient-labels': readingIngredientLabels,
  'ai-ingredient-scanner': aiIngredientScanner,
  'beyond-ai-diet-apps': beyondAiDietApps,
  'rise-ai-nutrition-apps': riseAiNutritionApps,
  'future-food-transparency': futureFoodTransparency,
  'ai-nutrition-coach-vs-nutritionists': aiNutritionCoachVsNutritionists,
  'ai-food-lens-vs-traditional-food-apps': aiFoodLensVsTraditionalFoodApps,
  'makes-healthy-choice-affordable': makesHealthyChoiceAffordable,
  'food-ingredient-scanner': foodIngredientScanner,
};
